import { collection, doc, getDoc, getDocs, getFirestore, orderBy, query, where } from "firebase/firestore";
import { messageThreadConverter } from "../converters/messageThreadConverter";
import { MessageThreadMember } from "../types/MessageThread";
import { queryEmployee } from "./queryEmployee";

export const queryMessageThreads = async (idNumber: string, members: string[]) => {
  const db = getFirestore();

  const q = query(
    collection(db, `Employees/${idNumber}/Messages`), 
    where('membersId', 'in', [members.sort((a, b) => a.localeCompare(b))]),
    orderBy('lastUpdate', 'desc')
  ).withConverter(messageThreadConverter);

  return (await getDocs(q)).docs.map((d) => d.data());
};

export const queryMessageThread = async (idNumber: string, threadId: string) => {
  const db = getFirestore();
  const ref = doc(db, `Employees/${idNumber}/Messages/${threadId}`).withConverter(messageThreadConverter);
  const messageThread = (await getDoc(ref)).data()
  if (messageThread !== undefined) {
    let members: MessageThreadMember[] = messageThread.members
    for (let i = 0; i < messageThread.members.length; i++) {
      members[i] = { 
        ...members[i], 
        employee: await queryEmployee(messageThread.members[i].idNumber) 
      }
    }
    return { ...messageThread, members };
  }
  return undefined;
};